var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { brandingHelpers } from '@simwood/nv-react-components-v2';
import { isElectron, isWeb } from '../helpers/platform';
import * as platform from '../helpers/platformApi';
import { capitalize } from '../helpers/util';
import { finaliseLogout } from './user';
const initialState = {
    isFetching: false,
    isInitialized: false,
    error: undefined,
    apiRoot: '',
    brand: '',
    website: '',
    partnerLogoSrc: '',
    appLogoSrc: '',
};
export const fetchBranding = createAsyncThunk('branding/fetch', (partnerId) => __awaiter(void 0, void 0, void 0, function* () {
    const { brand: res } = yield brandingHelpers.fetchBranding(partnerId);
    yield platform.setRequestReferer(res.website || '');
    brandingHelpers.applyBranding(res, 'communicator', isWeb());
    return res;
}));
const brandingSlice = createSlice({
    name: 'branding',
    initialState,
    reducers: {
        brandingReset: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranding.pending, (state) => {
            state.isFetching = true;
        })
            .addCase(fetchBranding.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.error;
        })
            .addCase(fetchBranding.fulfilled, (state, action) => {
            const { branding, apps, apiRoot, brand, website, companyLogoSrc, productLogoSrc, } = action.payload;
            const { favicons } = apps.communicator;
            const processedApps = [];
            const iconBaseUrl = process.env.NODE_ENV === 'development'
                ? 'https://my.nimvelo.com'
                : '';
            Object.keys(apps).forEach((appName) => {
                const { color1, color2, url, hideFromMenu } = apps[appName];
                if (hideFromMenu)
                    return;
                let iconUrl = `${iconBaseUrl}/branding/icons?name=${appName}`;
                iconUrl += `&color1=${color1.replace('#', '')}`;
                if (color2) {
                    iconUrl += `&color2=${color2.replace('#', '')}`;
                }
                processedApps.push({
                    name: capitalize(appName),
                    icon: iconUrl,
                    url,
                });
            });
            state.apps = processedApps;
            state.branding = branding;
            state.apiRoot = apiRoot;
            state.brand = brand;
            state.website = website;
            state.partnerLogoSrc = companyLogoSrc;
            state.appLogoSrc = productLogoSrc || companyLogoSrc;
            state.favicons = favicons;
            state.kbLinkLocation = apps.communicator.kbLinkLocation;
            state.isFetching = false;
            state.isInitialized = true;
        })
            .addCase(finaliseLogout.fulfilled, () => {
            if (isElectron()) {
                brandingHelpers.resetBranding(true);
                return initialState;
            }
        });
    },
});
export const { brandingReset } = brandingSlice.actions;
export default brandingSlice.reducer;
